import {
  faArrowRightArrowLeft,
  faBuilding,
  faEnvelope,
  faEnvelopeOpen,
  faUsers,
  faWrench,
} from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition } from 'src/components/Icon';
import { PlatformTab } from 'src/models/platform/_types';
interface DecoratedNavItem extends PlatformTab {
  reactRoute?: string;
  icon?: IconDefinition;
  children?: DecoratedNavItem[];
  target?: string;
}

export const useAdminNav = (): DecoratedNavItem[] => {
  return [
    {
      id: 'platforms',
      name: 'Platforms',
      route: '',
      reactRoute: '/admin/platform',
      icon: faBuilding,
      enabled: true,
    },
    {
      id: 'users',
      name: 'Users',
      route: '',
      reactRoute: '/admin/user',
      icon: faUsers,
      enabled: true,
    },
    {
      id: 'emails',
      name: 'Email Templates',
      icon: faEnvelope,
      route: '',
      reactRoute: '/admin/emails',
      enabled: true,
    },
    {
      id: 'email_history',
      name: 'Email History',
      route: '',
      reactRoute: '/admin/email_history',
      icon: faEnvelopeOpen,
      enabled: true,
    },
    {
      id: 'migrations',
      name: 'Migrations',
      route: '',
      reactRoute: '/admin/migration',
      icon: faArrowRightArrowLeft,
      enabled: true,
    },
    {
      id: 'utilities',
      name: 'Utilities',
      route: '',
      reactRoute: '/admin/utilities/update_twilio_numbers',
      icon: faWrench,
      enabled: true,
      children: [
        {
          id: 'twilio',
          name: 'Twilio Admin',
          route: '',
          reactRoute: '/admin/utilities/update_twilio_numbers',
          enabled: true,
        },
        {
          id: 'hello-bar',
          name: 'Hello Bar',
          route: '',
          reactRoute: '/admin/utilities/hello-bar',
          enabled: true,
        },
      ],
    },
  ];
};
